import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const CreditDetails = ({ modalOpen, setModalOpen, credit_sale }) => {

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Credit Sale Details"
      >
        <h4>Items Purchased</h4>
        <table>
            <thead>
                <tr>
                    <th className="text-left">Item Name</th>
                    <th className="text-left">Quantity</th>
                    <th className="text-left">Price</th>
                </tr>
            </thead>
            <tbody>
                {
                    credit_sale?.items?.map((item, index)=> (
                        <tr key={index}>
                            <td>
                                {item?.drug}
                            </td>
                            <td>
                                {item?.quantity}
                            </td>
                            <td>
                                {item?.total_cost}
                            </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default CreditDetails;
